import { render, staticRenderFns } from "./supplierManage.vue?vue&type=template&id=a9252f0e&scoped=true&"
import script from "./supplierManage.vue?vue&type=script&lang=js&"
export * from "./supplierManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9252f0e",
  null
  
)

component.options.__file = "supplierManage.vue"
export default component.exports